import Buttons from './Buttons'
import { Heading } from '@components/gassan-ui/Typography/Heading'
import { Box, SpecialSpan } from '@gassan-ui'
import { cn } from '@lib/cn'
import { FC } from 'react'

type Props = {
  title: string
  subtitle: string
  usps: string[]
  handleMakeAppointment: () => void
  handleGetInContact: () => void
}

const ProductInformation: FC<Props> = ({
  title,
  subtitle,
  usps,
  handleMakeAppointment,
  handleGetInContact,
  ...rest
}) => {
  return (
    <div className="flex h-full w-full max-w-[376px] flex-col justify-between">
      <div className={cn('mb-6', 'md:mb-10')}>
        <h1 data-test-id="product-page-title">
          <Heading variant="h1" as="span" className={cn('mb-1 block', 'sm:mb-4')}>
            {title}
          </Heading>
          <SpecialSpan color="shades.500" variant="two">
            {subtitle}
          </SpecialSpan>
        </h1>
      </div>

      <Box>
        <Buttons
          usps={usps}
          handleMakeAppointment={handleMakeAppointment}
          handleGetInContact={handleGetInContact}
          {...rest}
        />
      </Box>
    </div>
  )
}

export default ProductInformation
